export enum FilterType {
    String,
    Number,
    DateTime,
    Bool,
    Guid,
    GuidList,
    Enum
  }
